import React, { useContext, useEffect, useState } from 'react';
import HamburgerMenu from 'react-hamburger-menu';
import Breakpoint from 'react-socks';
import { useHeaderData } from '@interness/web-core/src/hooks';
import Logo from '@interness/web-core/src/components/media/Logo/Logo';
import NewMenuStructure from '@interness/web-core/src/components/structure/MenuStructure/NewMenuStructure';
import { GlobalContext } from '@interness/web-core/src/providers';
import Link from '@interness/web-core/src/components/elements/Link/Link';
import * as S from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
const Header = () => {
  const {
    0: mounted,
    1: setMounted
  } = useState(false);
  const data = useHeaderData();
  const {
    primaryMenuOpen,
    togglePrimaryMenu
  } = useContext(GlobalContext);
  const toggleMenu = () => togglePrimaryMenu(!primaryMenuOpen);
  useEffect(() => {
    setMounted(true);
  }, []);
  const menuFirstHalf = data.menuNew.slice(0, data.menuNew.length / 2);
  const menuSecondHalf = data.menuNew.slice(data.menuNew.length / 2);
  return ___EmotionJSX(S.Header, null, mounted && ___EmotionJSX(S.Nav, null, ___EmotionJSX(Breakpoint, {
    large: true,
    up: true
  }, ___EmotionJSX(NewMenuStructure, {
    menu: menuFirstHalf
  })), ___EmotionJSX(Breakpoint, {
    medium: true,
    down: true
  }, ___EmotionJSX(HamburgerMenu, {
    isOpen: primaryMenuOpen,
    menuClicked: toggleMenu,
    strokeWidth: 3,
    borderRadius: 5
  }))), ___EmotionJSX(S.Logo, null, ___EmotionJSX(Link, {
    to: "/"
  }, ___EmotionJSX(Logo, {
    logo: data.logo.localFile,
    title: data.seo_title
  }))), mounted && ___EmotionJSX(S.Nav, {
    second: true
  }, ___EmotionJSX(Breakpoint, {
    large: true,
    up: true
  }, ___EmotionJSX(NewMenuStructure, {
    menu: menuSecondHalf
  }))), ___EmotionJSX(S.CartSection, {
    id: "int-cart"
  }), !mounted && ___EmotionJSX(HamburgerMenu, {
    isOpen: primaryMenuOpen,
    menuClicked: toggleMenu,
    strokeWidth: 3,
    borderRadius: 5
  }));
};
export default Header;